import React, { useEffect, useState } from 'react'
import { Interweave } from 'interweave';

interface I24HrTime {
  hours: number
  minutes: number
}

interface ISettings {
  promiseTextUSA: string
  promiseTextOver: string
  cutoffUSA: I24HrTime,
  excludedDays: number[]
  excludedDates: Date[]

}

const stringToDate = (str: string): Date => {
  const [date, month, year] = str.split('/').map(s => parseInt(s));
  return new Date(year, month - 1, date)
}

const getSettings = (): null|ISettings => {
  const settingsScriptElUSA = document.getElementById('delivery_promise_settings_usa');
  if (!settingsScriptElUSA) return null
  try {
    const {promiseTextUSA, promiseTextOver, cutoffUSA, excludedDays, excludedDates} = JSON.parse(settingsScriptElUSA.textContent)
    return {
      promiseTextUSA,
      promiseTextOver,
      cutoffUSA: {
        hours: parseInt(cutoffUSA?.split(':')[0]),
        minutes: parseInt(cutoffUSA?.split(':')[1])
      },
      excludedDays: excludedDays.map((day: string) => parseInt(day)),
      excludedDates: excludedDates.map(stringToDate)
    }
  } catch (e) {
    console.error(e)
    return null
  }
}

const getCutoffForDate = (cutoff: I24HrTime, date: Date): Date => {
  const copyDate = new Date(date.getTime())
  copyDate.setHours(cutoff.hours)
  copyDate.setMinutes(cutoff.minutes)
  copyDate.setSeconds(0)
  return copyDate
}

const formatTimeRemaining = (ms: number) => {
  const minutesTilCutoff = Math.floor(ms / (60 * 1000)) % 60
  const hoursTilCutoff = Math.floor(ms / (60 * 60 * 1000)) % 24
  return `${hoursTilCutoff > 0 ? `${hoursTilCutoff}hrs ` : ''}${minutesTilCutoff}mins`
}

const matchDate = (a: Date, b: Date) : boolean => {
  if (a.getFullYear() !== b.getFullYear()) return false
  if (a.getMonth() !== b.getMonth()) return false
  if (a.getDate() !== b.getDate()) return false
  return true
}

const DeliveryPromiseUSA: React.FunctionComponent = () => {
  const [settings, setSettings] = useState(null as ISettings)
  const [rightNow, setRightNow] = useState(new Date())
  const [today, setToday] = useState((new Date()).getDay())
  const [todaysCutoff, setTodaysCutoff] = useState(null as Date)
  const isUSALocale = window.Shopify.country === 'US';

  const USAConfidenceDelivery = document.querySelector('.confidence-delivery-usa');

  if(isUSALocale && USAConfidenceDelivery) {
    USAConfidenceDelivery.classList.remove('hide');
  }

  useEffect(() => {
    //if the day changes, get the new cutoff
    if (settings) {
      setTodaysCutoff(getCutoffForDate(settings.cutoffUSA, rightNow))
    }
  }, [today, settings])

  useEffect(() => {
    //see if we've changed day
    if (rightNow.getDay() !== today) {
      setToday(rightNow.getDay())
    }
  }, [rightNow])

  useEffect(() => {
    setSettings(getSettings())
    const interval = window.setInterval(() => {
      //every second update
      setRightNow(new Date())
    }, 1000)
    return () => window.clearInterval(interval)
  },
  [])

  if (!todaysCutoff) return null

  const timeRemaining = todaysCutoff.getTime() - rightNow.getTime()

  if (
    settings.excludedDates.some(date => matchDate(date, rightNow)) ||
    settings.excludedDays.includes(today) ||
    Math.floor((timeRemaining) / (60 * 1000)) < 1
  ) {
    // if we're on an exluded date
    // if we're on an excluded day
    // if we're past the cutoff
    return <><Interweave content={settings.promiseTextOver} noWrap={true} /></>
  }

  return (
    <>
      {isUSALocale && (
        <Interweave content={settings.promiseTextUSA.replace('[[time]]', formatTimeRemaining(timeRemaining))} noWrap={true} />
      )}
    </>
  )
}

export default DeliveryPromiseUSA